import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostStocksSkuParams, TypePostStocksSkuResponse, TypeStockSku } from '~/types/stock.types';

const usePostStocksSku = () => {
  const endPoint = '/api-inventory/v1/third-parties/stocks/sku';

  const postStocksSku = async (params: TypePostStocksSkuParams) => {
    return axiosInstance
      .post<TypePostStocksSkuResponse>(endPoint, {
        ...params,
      })
      .then(({ data: { data, pagination } }) => {
        return { data, pagination };
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postStocksSku };
};

export default usePostStocksSku;

const mockStockSku = (index: number, overrides: Partial<TypeStockSku> = {}): TypeStockSku => ({
  warehouseCode: 'GGM1',
  clusterName: '김포',
  skuCode: `M000003076${String(index).padStart(2, '0')}`,
  alterCode: `88123123130${index}`,
  skuName: `(센터명)재고상품${index}`,
  temperatureType: '냉장',
  totalQuantity: 1200,
  availableQuantity: 1000,
  allocationQuantity: 100,
  holdingQuantity: 50,
  defectiveQuantity: 50,
  ...overrides,
});

const stocksSkuNormalResponse: TypePostStocksSkuResponse = {
  data: [
    mockStockSku(1),
    mockStockSku(2, { clusterName: '평택', warehouseCode: 'GPH1', temperatureType: '상온', totalQuantity: 35000 }),
    mockStockSku(3, { temperatureType: '냉동', availableQuantity: 0, allocationQuantity: 0, holdingQuantity: 0 }),
    mockStockSku(4, { skuName: '(센터명)이름이 아주 긴 재고 상품명 — 말줄임 확인용 긴 상품명 텍스트' }),
    mockStockSku(5, { defectiveQuantity: 0 }),
  ],
  pagination: { listView: 100, listTotal: 5, cursor: 0 },
};

registerMockAPI<TypePostStocksSkuResponse>({
  method: 'post',
  endpoint: '/api-inventory/v1/third-parties/stocks/sku',
  label: '재고/상품별조회/재고목록',
  scenarios: [
    { name: '정상 응답', response: stocksSkuNormalResponse },
    { name: '검색 결과 0건', response: { data: [], pagination: { listView: 100, listTotal: 0, cursor: 0 } } },
  ],
});
